<template>
  <v-container fluid fill-height align-start pa-0 class="pageWrap">
    <v-sheet class="contents-container">
      <i-card-vertical headerTitle="관계법령 관리대장" device="web">
        <template v-slot:body>
          <v-layout column>
            <v-col cols="12" md="12" class="row pa-0">
              <v-col cols="12" class="pa-0">
                <DxDataGrid
                  id="mainGrid"
                  class="layout-col-height00"
                  width="100%"
                  :ref="dxDataGridRef"
                  :data-source="gridMain"
                  :remote-operations="false"
                  :hover-state-enabled="true"
                  :allow-column-reordering="true"
                  :allow-column-resizing="true"
                  :row-alternation-enabled="true"
                  :column-auto-width="true"
                  :show-borders="true"
                  :show-row-lines="true"
                  :selection="{ mode: 'single' }"
                  key-expr="id"
                  :focused-row-enabled="true"
                  @editing-start="onEditingStart"
                  @row-updating="onRowUpdating"
                  @editor-preparing="onEditorPreparing"
                  @selection-changed="onSelectionChanged"
                  @cell-prepared="onCellPrepared"
                >
                  <DxEditing mode="batch" :allow-updating="true" :select-text-on-edit-start="true" />

                  <DxSelection :select-all-mode="allMode" show-check-boxes-mode="always" mode="multiple" />
                  <DxColumn
                    width="120px"
                    data-field="readOnly"
                    data-type="string"
                    alignment="center"
                    caption="구분"
                    :allow-editing="true"
                    cell-template="readonlyCellTemplate"
                  />
                  <template #readonlyCellTemplate="{ data: cellInfo }">
                    <div>
                      <span>{{ cellInfo.data.readOnly ? '소중안 제공' : '고객사 전용' }}</span>
                    </div>
                  </template>
                  <DxColumn
                    width="390px"
                    css-class="devest-grid-header-require"
                    data-field="lawNm"
                    data-type="string"
                    alignment="left"
                    caption="법령명"
                    :allow-editing="true"
                  />
                  <DxColumn
                    width="120px"
                    css-class="devest-grid-header-require"
                    data-field="lawTypeCd"
                    data-type="string"
                    alignment="center"
                    caption="법령구분"
                    :allow-editing="true"
                  >
                    <DxLookup :data-source="lawTypeList" value-expr="minorCd" display-expr="minorNm" :allow-editing="true" />
                  </DxColumn>

                  <DxColumn
                    width="450px"
                    css-class="devest-grid-header-require"
                    data-field="fileList"
                    data-type="string"
                    alignment="center"
                    caption="파일"
                    cell-template="fileCellTemplate"
                    :allow-editing="false"
                  />
                  <template #fileCellTemplate="{ data: cellInfo }">
                    <div style="display: flex; align-items: center">
                      <!-- 파일 관리 팝업 -->
                      <i-dxpopup
                        :popupVisible="cellInfo.data.filePopupVisible"
                        :title="cellInfo.data.lawNm ? `파일 관리-${cellInfo.data.lawNm}` : '파일 관리'"
                        @popupCloseButtonClick="btnFilePopupClose('close')"
                        :isCloseOnOutsideClick="false"
                        height="600px"
                        width="450px"
                      >
                        <template v-slot:grid>
                          <div class="v-application">
                            <v-layout column style="height: 100%">
                              <v-row style="padding: 0 16px">
                                <iFileManage
                                  class="mt-5"
                                  style="width: 100%"
                                  :ref="`detailFileUpload_${cellInfo.data.lawId}`"
                                  :titleDesc="''"
                                  :targetId="getFileTargetId(cellInfo.data)"
                                  :targetType="'00028'"
                                  @onFileChanged="onFileChanged(cellInfo, $event)"
                                  :readOnly="isRowReadOnly(cellInfo.data)"
                                />
                              </v-row>
                            </v-layout>
                          </div>
                        </template>
                        <template v-slot:footer>
                          <div class="v-application">
                            <v-row class="d-flex justify-end" style="gap: 12px; padding-right: 10px">
                              <v-btn
                                v-if="!isRowReadOnly(cellInfo.data)"
                                elevation="0"
                                large
                                color="primary"
                                class="float-right rounded mt-1"
                                @click="btnFilePopupApply(cellInfo)"
                                >적용</v-btn
                              >
                              <v-btn elevation="0" large color="desc_text" class="float-right rounded mt-1" @click="btnFilePopupClose('close')"
                                >닫기</v-btn
                              >
                            </v-row>
                          </div>
                        </template>
                      </i-dxpopup>

                      <div style="overflow-x: auto; white-space: nowrap; flex: 1 1 auto; min-width: 0; margin-right: 8px">
                        <span v-if="cellInfo.data.fileList && cellInfo.data.fileList.length > 1">
                          {{ `${cellInfo.data.fileList[0].fileNm}.${cellInfo.data.fileList[0].extension} 외 ${cellInfo.data.fileList.length - 1}개` }}
                        </span>
                        <span v-else-if="cellInfo.data.fileList && cellInfo.data.fileList.length == 1">
                          {{ `${cellInfo.data.fileList[0].fileNm}.${cellInfo.data.fileList[0].extension}` }}
                        </span>
                        <span v-else>
                          {{ '' }}
                        </span>
                      </div>
                      <div style="flex: none; position: sticky; right: 0; z-index: 2">
                        <v-icon size="28" @click="btnFilePopup(cellInfo)">mdi-file</v-icon>
                      </div>
                    </div>
                  </template>

                  <DxColumn
                    data-field="save"
                    data-type="string"
                    width="120px"
                    alignment="center"
                    caption
                    :allow-editing="false"
                    cell-template="actionTemplete"
                  ></DxColumn>
                  <template #actionTemplete="{ data: cellInfo }">
                    <div>
                      <v-btn
                        :id="`historyBtn_${cellInfo.data.id}`"
                        color="primary"
                        elevation="0"
                        dark
                        small
                        class="rounded px-3 grid-btn"
                        :disabled="cellInfo.data.__created__"
                        @click="btnHistory(cellInfo.data)"
                        >이력보기</v-btn
                      >
                    </div>
                  </template>
                </DxDataGrid>
              </v-col>
            </v-col>
          </v-layout>
        </template>
      </i-card-vertical>
      <v-sheet class="iCardRightWrap">
        <i-card-right :useBtnList="buttonUseList" @btnSearch="btnSearch(true)" @btnAdd="btnAdd()" @btnSave="btnSave()" @btnDelete="btnDelete()">
        </i-card-right>
      </v-sheet>
    </v-sheet>

    <!-- 이력 툴팁 -->
    <DxTooltip
      :visible="historyTooltipVisible"
      :target="historyTarget"
      position="top"
      :hide-on-outside-click="true"
      :width="480"
      @hiding="historyTooltipVisible = false"
      @shown="onHistoryTooltipShown"
    >
      <template #content>
        <div class="v-application history-tooltip">
          <div class="history-tooltip-title">{{ `변경 이력(최근 ${historyLimit}개)` }}</div>
          <div ref="historyTooltipBody" class="history-tooltip-body" tabindex="-1">
            <template v-if="historyData.length">
              <div v-for="(item, idx) in historyData" :key="idx" class="history-tooltip-item">
                <div class="history-tooltip-meta">
                  <div class="history-tooltip-meta-left">
                    <span>{{ item.createdAt }}</span>
                    <span>-</span>
                    <span>{{ item.createdBy }}</span>
                  </div>
                  <span v-if="getHistoryFieldNm(item.fieldId)" class="history-tooltip-field-chip">{{ getHistoryFieldNm(item.fieldId) }}</span>
                </div>
                <div class="history-tooltip-compare">
                  <div class="history-tooltip-col">
                    <span class="history-tooltip-label">변경 전</span>
                    <v-tooltip bottom max-width="400" open-delay="200">
                      <template #activator="{ on, attrs }">
                        <div class="history-tooltip-value history-tooltip-before" v-bind="attrs" v-on="on">
                          {{ formatHistoryDisplayValue(item.before) }}
                        </div>
                      </template>
                      <span class="history-tooltip-full-text">{{ formatHistoryTooltipValue(item.before) }}</span>
                    </v-tooltip>
                  </div>
                  <div class="history-tooltip-arrow">→</div>
                  <div class="history-tooltip-col">
                    <span class="history-tooltip-label">변경 후</span>
                    <v-tooltip bottom max-width="400" open-delay="200">
                      <template #activator="{ on, attrs }">
                        <div class="history-tooltip-value history-tooltip-after" v-bind="attrs" v-on="on">
                          {{ formatHistoryDisplayValue(item.after) }}
                        </div>
                      </template>
                      <span class="history-tooltip-full-text">{{ formatHistoryTooltipValue(item.after) }}</span>
                    </v-tooltip>
                  </div>
                </div>
              </div>
            </template>
            <div v-else class="history-tooltip-empty">이력이 없습니다.</div>
          </div>
        </div>
      </template>
    </DxTooltip>
  </v-container>
</template>
<script>
// components
import iCardRight from '@/components/common/iCardRight.vue'
import iCardVertical from '@/components/common/iCardVertical.vue'
import baseview from '@/views/base/baseview.vue' //20220414 LYJ base page 추가
import BaseDataGrid from '@/views/base/BaseDataGrid.vue' //20220509 LYJ 데이타 그리드 사용시 베이스 추가
import iDxPopup from '@/components/common/iDxPopup.vue'
import iFileManage from '@/components/esgCommon/iFileManage.vue'
import { getGrpAuthCd } from '@/utils/token'
import { getCommonCode } from '@/api/common/commonApi'
// utils
import { getExtension, getDateTimeFormat } from '@/utils/common.js'
// api
import { deleteFilesWithTarget, deleteFiles, multiFileUpload } from '@/api/baseManage/fileUpload'
import {
  getRelatedLegisManageList,
  saveRelatedLegisManageList,
  deleteRelatedLegisManageList,
  getRelatedLegisManageHistory,
} from '@/api/leaderShip/relatedLegisManage'
import { DxFileUploader } from 'devextreme-vue/file-uploader'
import { DxTooltip } from 'devextreme-vue/tooltip'
import _ from 'lodash'

import iSearchPanel from '@/components/common/iSearchPanel.vue'

export default {
  mixins: [baseview, BaseDataGrid], //20220414 LYJ base page 추가
  name: 'RelatedLegisManage',
  components: {
    'i-card-vertical': iCardVertical,
    'i-dxpopup': iDxPopup,
    iCardRight,
    iFileManage,
    DxFileUploader,
    DxTooltip,
    iSearchPanel,
  },
  data() {
    return {
      buttonUseList: [
        'btnSearch', //조회
        'btnAdd', //추가
        'btnSave', //저장
        'btnDelete', //삭제
      ],
      dxDataGridRef: 'mainGrid',
      dxSampleDataGridRef: 'sampleGrid',
      dxSdsManageGridRef: 'sdsManageGrid',
      dxSdsManageFileUploaderRef: 'sdsManageFileUploader',
      gridMain: [],
      sampleData: [],
      sdsManageData: [],
      allMode: 'allPages',
      selectedDataIndex: -1,
      fileListForm: {
        insert: [],
        delete: [],
      },
      lawTypeList: [],
      historyData: [],
      historyTooltipVisible: false,
      historyTarget: '',
      // 저장 시점 변경 비교를 위한 원본 데이터 스냅샷 (lawId -> row)
      originalRowMap: {},
      // 변경이력으로 추적할 컬럼 정의
      // codeList가 있으면 코드값을 표시 텍스트로 변환해서 저장
      historyTrackFields: [
        { fieldId: 'lawNm', fieldNm: '법령명' },
        { fieldId: 'lawTypeCd', fieldNm: '법령구분', codeList: 'lawTypeList' },
        { fieldId: 'fileList', fieldNm: '파일', type: 'fileList' },
      ],
      historyLimit: 3,
    }
  },
  computed: {
    mobileTrigger: function () {
      return this.getWidth() < 1920
    },
    isMasterConfig() {
      return getGrpAuthCd() === 'master'
    },
    selectedData() {
      return this.gridMain[this.selectedDataIndex]
    },
  },
  created() {},
  beforeMount() {
    this.enableEditColumn = ['lawNm', 'lawTypeCd', 'createdAt', 'createdBy', 'updatedAt', 'updatedBy']
  },
  async mounted() {
    await this.initLawTypeList()
    this.btnSearch(true)
  },
  activated() {},
  methods: {
    async initLawTypeList() {
      await getCommonCode('RA001').then((res) => {
        if (res.success) {
          this.lawTypeList = res.list || []
          this.applyLawTypeNmToGrid()
        }
      })
    },
    getLawTypeNm(lawTypeCd) {
      const found = this.lawTypeList.find((item) => item.minorCd === lawTypeCd)
      return found ? found.minorNm : ''
    },
    applyLawTypeNmToGrid() {
      this.gridMain.forEach((row) => {
        row.lawTypeNm = this.getLawTypeNm(row.lawTypeCd)
      })
    },
    isRowReadOnly(row) {
      if (this.isMasterConfig) return false
      return row?.readOnly === true
    },
    onEditingStart(e) {
      if (this.isRowReadOnly(e.data)) {
        e.cancel = true
        return
      }
      if (this.enableEditColumn.indexOf(e.column.dataField) > -1) {
        e.cancel = false
      } else {
        e.cancel = true
      }
    },
    onSelectionChanged(e) {
      const readOnlyKeys = e.selectedRowsData?.filter((row) => this.isRowReadOnly(row)).map((row) => row.lawId)
      if (readOnlyKeys?.length > 0) {
        e.component.deselectRows(readOnlyKeys)
      }
    },
    onCellPrepared(e) {
      if (e.rowType !== 'data') return
      if (e.data?.readOnly === true) {
        e.cellElement?.classList.add('blue-cell')
      } else {
        e.cellElement?.classList.remove('blue-cell')
      }
    },
    onCellValueChanged(value, cellInfo) {
      if (this.isRowReadOnly(cellInfo.data)) return
      if (cellInfo.dataType == 'datetime') {
        cellInfo.setValue(getDateTimeFormat(value))
      } else {
        cellInfo.setValue(value)
      }
      if (cellInfo.column?.dataField === 'lawTypeCd') {
        const row = this.gridMain.find((r) => r.lawId === cellInfo.row.key)
        if (row) row.lawTypeNm = this.getLawTypeNm(value)
      }
      cellInfo.component.selectRows(cellInfo.row.key, true)
    },
    btnSearch(notify = false) {
      this.openLoading('searching')
      this.GetDataGrid(this.dxDataGridRef).endUpdate()
      getRelatedLegisManageList({ clntId: this.getClntId() }, notify)
        .then((res) => {
          if (res.success) {
            res.list?.forEach((el) => {
              el.saveFileList = _.cloneDeep(this.fileListForm)
              el.filePopupVisible = false
              el.clntId = el.clntId || this.getClntId()
              el.targetId = this.getFileTargetId(el)
            })
            this.gridMain = res.list || []
            this.applyLawTypeNmToGrid()
          }
        })
        .catch(() => {
          this.endLoading()
        })
        .finally(async () => {
          await this.gridInit(this.GetDataGrid(this.dxDataGridRef))
          if (this.gridMain.length > 0) {
            await this.FocusFirstRow(this.GetDataGrid(this.dxDataGridRef))
          }
          this.snapshotOriginalRows()
          this.endLoading()
        })
    },
    getFileTargetId(row) {
      const clntId = row.clntId || this.getClntId()
      return `${clntId}_${row.lawId}`
    },
    btnAdd() {
      const newRow = {
        id: `NEW_${Date.now()}`,
        lawId: `NEW_${Date.now()}`, // 임시 키 (저장 시 서버 키로 대체)
        lawNm: '',
        lawTypeCd: '',
        lawTypeNm: '',
        fileList: [],
        saveFileList: _.cloneDeep(this.fileListForm),
        filePopupVisible: false,
        clntId: this.getClntId(),
        targetId: '',
        readOnly: false,
        __created__: true, // 신규 추가 로우 표시
      }
      newRow.targetId = this.getFileTargetId(newRow)
      // 최상단에 추가
      this.gridMain.unshift(newRow)

      const grid = this.$refs[this.dxDataGridRef] && this.$refs[this.dxDataGridRef].instance
      if (grid) {
        grid.refresh()
        // 추가된 로우 체크 및 최상단으로 포커스
        grid.selectRows([newRow.lawId], true)
        grid.option('focusedRowIndex', 0)
      }
    },
    async btnSave() {
      const grid = this.GetDataGrid(this.dxDataGridRef)
      const changes = grid.option('editing.changes') || []
      await grid.saveEditData()
      const selectedRows = await grid.getSelectedRowsData()

      if (selectedRows.length === 0) {
        this.vSnackbar(this.$t('selectionData'), 'warn')
        return
      }
      if (selectedRows.some((row) => this.isRowReadOnly(row))) {
        this.vSnackbar('소중안 제공 데이터는 저장할 수 없습니다.', 'warn')
        return
      }
      if (selectedRows.some((row) => !row.lawNm || row.lawNm.trim() === '')) {
        this.vSnackbar('법령명은 필수입력 값입니다.', 'warn')
        return
      }
      if (selectedRows.some((row) => !row.lawTypeCd)) {
        this.vSnackbar('법령구분은 필수입력 값입니다.', 'warn')
        return
      }
      if (selectedRows.some((row) => !row.fileList || row.fileList.length === 0)) {
        this.vSnackbar('파일은 필수입력 값입니다.', 'warn')
        return
      }

      this.vToastifyPrompt(`${selectedRows.length}개의 데이터를 저장하시겠습니까?`, 'info', async () => {
        this.openLoading('saving')

        try {
          const historyMap = this.buildChangeHistory(changes, selectedRows)
          console.log('btnSave - 변경이력', historyMap)

          const saveList = selectedRows.map((row) => ({
            ...row,
            clntId: this.getClntId(),
            historyList: historyMap[row.lawId] || [],
          }))

          for (const row of saveList) {
            const res = await saveRelatedLegisManageList([row], true)
            if (!res.success) continue

            const saved = res.list?.[0]
            if (!saved || !row.saveFileList) continue

            const hasFileChanges = row.saveFileList.insert.length > 0 || row.saveFileList.delete.length > 0
            if (!hasFileChanges) continue

            const targetId = `${saved.clntId}_${saved.lawId}`
            row.saveFileList.delete.forEach((el) => {
              el.targetId = targetId
              el.clntId = saved.clntId
            })
            row.saveFileList.insert.forEach((el) => {
              el.targetId = targetId
              el.clntId = saved.clntId
            })
            await this.saveFile(row.saveFileList)
          }

          this.btnSearch(false)
        } catch (e) {
          console.error(e)
        } finally {
          this.endLoading()
        }
      })
    },
    // 현재 그리드 데이터를 lawId 기준으로 깊은 복사하여 원본 스냅샷 저장
    snapshotOriginalRows() {
      const map = {}
      this.gridMain.forEach((row) => {
        map[row.lawId] = JSON.parse(JSON.stringify(row))
      })
      this.originalRowMap = map
    },
    getHistoryFieldNm(fieldId) {
      const def = this.historyTrackFields.find((f) => f.fieldId === fieldId)
      return def ? def.fieldNm : ''
    },
    // 코드값을 표시 텍스트로 변환
    convertCodeToText(fieldId, value) {
      const def = this.historyTrackFields.find((f) => f.fieldId === fieldId)
      if (!def || !def.codeList) return value
      const list = this[def.codeList] || []
      const found = list.find((item) => item.minorCd === value)
      return found ? found.minorNm : value
    },
    // fileList 비교/저장용 문자열 생성 (fileNm.extension, 복수 시 쉼표 구분)
    stringifyFileList(fileList) {
      if (!Array.isArray(fileList) || fileList.length === 0) return ''
      return fileList.map((f) => `${f.fileNm}${f.extension ? '.' + f.extension : ''}`).join(', ')
    },
    // 변경이력 저장용 필드 값 포맷 (fileList → 문자열, codeList → 표시 텍스트)
    formatHistoryFieldValue(def, value) {
      if (def.type === 'fileList') {
        return this.stringifyFileList(value) || null
      }
      if (def.codeList) {
        return value === undefined || value === null || value === '' ? null : this.convertCodeToText(def.fieldId, value)
      }
      return value ?? null
    },
    // 신규 로우 INSERT 변경 항목 배열 생성
    buildInsertHistoryChanges(row) {
      const clntId = row.clntId || this.getClntId()
      return this.historyTrackFields.map((def) => ({
        clntId,
        fieldId: def.fieldId,
        before: null,
        after: this.formatHistoryFieldValue(def, row[def.fieldId]),
      }))
    },
    // 원본/현재 로우를 필드별로 비교하여 변경 항목 배열 반환 (파일 등 팝업 변경 포함)
    compareRowFields(before, after) {
      const clntId = after.clntId || this.getClntId()
      const fieldChanges = []
      this.historyTrackFields.forEach((def) => {
        const fieldId = def.fieldId
        const beforeVal = before ? before[fieldId] : undefined
        const afterVal = after[fieldId]

        const beforeFormatted = before ? this.formatHistoryFieldValue(def, beforeVal) : null
        const afterFormatted = this.formatHistoryFieldValue(def, afterVal)

        if (String(beforeFormatted ?? '') !== String(afterFormatted ?? '')) {
          fieldChanges.push({
            clntId,
            fieldId,
            before: beforeFormatted,
            after: afterFormatted,
          })
        }
      })
      return fieldChanges
    },
    // 선택 로우별 변경 항목 배열 반환 (lawId -> changes[])
    buildChangeHistory(changes, targetRows = []) {
      const historyMap = {}

      changes.forEach((change) => {
        if (change.type === 'remove') {
          historyMap[change.key] = []
        }
      })

      targetRows.forEach((row) => {
        const before = this.originalRowMap[row.lawId]

        if (row.__created__ || !before) {
          historyMap[row.lawId] = this.buildInsertHistoryChanges(row)
          return
        }

        const fieldChanges = this.compareRowFields(before, row)
        if (fieldChanges.length > 0) {
          historyMap[row.lawId] = fieldChanges
        }
      })

      return historyMap
    },
    async btnDelete() {
      const selectedRows = await this.GetDataGrid(this.dxDataGridRef).getSelectedRowsData()
      if (selectedRows.length === 0) {
        this.vSnackbar(this.$t('selectionData'), 'warn')
        return
      }
      if (selectedRows.some((row) => this.isRowReadOnly(row))) {
        this.vSnackbar('소중안 제공 데이터는 삭제할 수 없습니다.', 'warn')
        return
      }
      this.vToastifyPrompt(`${selectedRows.length}개의 데이터를 삭제하시겠습니까?`, 'info', async () => {
        this.openLoading('deleting')
        const deleteRowPromises = selectedRows.map((row) => {
          return deleteRelatedLegisManageList([row], true).then((res) => {
            if (res.success) {
              return deleteFilesWithTarget({
                clntId: row.clntId || this.getClntId(),
                targetType: '00028',
                targetId: row.targetId || this.getFileTargetId(row),
              })
            }
          })
        })
        Promise.all(deleteRowPromises)
          .then(() => {
            this.endLoading()
            this.btnSearch(false)
          })
          .catch(() => {
            this.endLoading()
          })
      })
    },
    btnHistory(data) {
      const target = `#historyBtn_${data.id}`
      if (this.historyTooltipVisible && this.historyTarget === target) {
        this.historyTooltipVisible = false
        return
      }
      getRelatedLegisManageHistory(
        {
          clntId: data.clntId || this.getClntId(),
          lawId: data.lawId,
          limit: this.historyLimit,
        },
        true
      ).then((res) => {
        if (res.success) {
          this.historyData = this.flattenHistoryList(res.list || [])
        } else {
          this.historyData = []
        }
        this.historyTarget = target
        this.historyTooltipVisible = true
      })
    },
    onHistoryTooltipShown() {
      this.$nextTick(() => {
        const el = this.$refs.historyTooltipBody
        if (!el) return
        el.focus({ preventScroll: true })
        if (el._historyWheelHandler) {
          el.removeEventListener('wheel', el._historyWheelHandler)
        }
        el._historyWheelHandler = (e) => this.onHistoryTooltipWheel(e)
        el.addEventListener('wheel', el._historyWheelHandler, { passive: false })
      })
    },
    onHistoryTooltipWheel(e) {
      e.stopPropagation()
      const el = e.currentTarget
      if (el.scrollHeight <= el.clientHeight) return
      e.preventDefault()
      el.scrollTop += e.deltaY
    },
    // 이력 API 응답을 툴팁 표시용 flat 배열로 변환
    flattenHistoryList(list) {
      return list.flatMap((record) => {
        if (Array.isArray(record.changes) && record.changes.length > 0) {
          return record.changes.map((change) => ({
            createdAt: record.createdAt,
            createdBy: record.createdBy,
            fieldId: change.fieldId,
            before: change.before,
            after: change.after,
          }))
        }
        return [
          {
            createdAt: record.createdAt,
            createdBy: record.createdBy,
            fieldId: record.fieldId,
            before: record.before,
            after: record.after,
          },
        ]
      })
    },
    formatHistoryDisplayValue(value) {
      if (value === null || value === undefined || value === '') return '-'
      return String(value)
    },
    formatHistoryTooltipValue(value) {
      if (value === null || value === undefined || value === '') return '-'
      const text = String(value)
      if (text.includes(', ')) return text.split(', ').join('\n')
      return text
    },
    // ------------------------------------------
    // 파일 관리 팝업
    // ------------------------------------------
    btnFilePopup(cellInfo) {
      this.selectedDataIndex = cellInfo.row.dataIndex
      this.GetDataGrid(this.dxDataGridRef).saveEditData()
      this.$set(this.selectedData, 'filePopupVisible', true)
      this.$nextTick(() => {
        this.filePopupOpen(cellInfo)
      })
    },
    filePopupOpen(cellInfo) {
      setTimeout(() => {
        const refKey = `detailFileUpload_${this.selectedData.lawId}`
        if (!this.$refs[refKey]) return
        this.$refs[refKey].files = _.cloneDeep(cellInfo.data.fileList || [])
        this.$refs[refKey].newFiles = []
      }, 100)
    },
    btnFilePopupApply(cellInfo) {
      if (this.isRowReadOnly(this.selectedData)) return
      if (!this.selectedData.saveFileList) {
        this.selectedData.saveFileList = _.cloneDeep(this.fileListForm)
      }
      if (this.selectedData.saveFileList.delete.length === 0 && this.selectedData.saveFileList.insert.length === 0) {
        this.btnFilePopupClose()
        return
      }
      const refKey = `detailFileUpload_${this.selectedData.lawId}`
      if (this.selectedData.saveFileList.delete.length === 0 && this.$refs[refKey] && this.$refs[refKey].newFiles.length === 0) {
        this.btnFilePopupClose()
        return
      }

      const filteredOldFiles = (this.selectedData.fileList || []).filter((file) => {
        return !this.selectedData.saveFileList.delete.some(
          (deleteItem) => file.fileNm === deleteItem.fileNm && file.extension === deleteItem.extension && file.fileSize === deleteItem.fileSize
        )
      })
      const filteredInsertFiles = this.selectedData.saveFileList.insert.filter((insertItem) => {
        return !this.selectedData.saveFileList.delete.some(
          (deleteItem) =>
            insertItem.fileNm === deleteItem.fileNm && insertItem.extension === deleteItem.extension && insertItem.fileSize === deleteItem.fileSize
        )
      })
      this.selectedData.fileList = [...filteredOldFiles, ...filteredInsertFiles]

      const targetIdx = this.gridMain.findIndex((row) => row.lawId === this.selectedData.lawId)
      if (targetIdx !== -1) {
        this.gridMain[targetIdx].filePopupVisible = false
        this.$set(this.gridMain, targetIdx, {
          ...this.gridMain[targetIdx],
          fileList: [...this.selectedData.fileList],
          saveFileList: _.cloneDeep(this.selectedData.saveFileList),
        })
      }

      cellInfo.component.selectRows(cellInfo.row.key, true)
      this.btnFilePopupClose('close')
    },
    btnFilePopupClose(rowIndex) {
      if (rowIndex !== 'close' && this.selectedData) {
        const refKey = `detailFileUpload_${this.selectedData.lawId}`
        if (this.$refs[refKey]) {
          this.$refs[refKey].saveFileList = _.cloneDeep(this.fileListForm)
        }
      }
      const dataGrid = this.GetDataGrid(this.dxDataGridRef)
      dataGrid.saveEditData && dataGrid.saveEditData()
      if (this.selectedData) {
        this.$set(this.selectedData, 'filePopupVisible', false)
      }
    },
    onFileChanged(cellInfo, fileList) {
      if (this.isRowReadOnly(cellInfo.data)) return
      cellInfo.data.saveFileList = fileList
    },
    async saveFile(files) {
      if (!files || (files.insert.length === 0 && files.delete.length === 0)) {
        return true
      }
      if (files.delete.length > 0) {
        const deleteRes = await deleteFiles(files.delete, false)
        if (!deleteRes.success) {
          return false
        }
      }
      if (files.insert.length === 0) {
        return true
      }
      const formData = new FormData()
      let i = 0
      files.insert.forEach((element) => {
        formData.append('fileList[' + i + '].fileData', element.file ? element.file : new Blob([], { type: 'application/octet-stream' }))
        formData.append('fileList[' + i + '].fileVO.targetId', element.targetId)
        formData.append('fileList[' + i + '].fileVO.targetType', '00028')
        formData.append('fileList[' + i + '].fileVO.useYn', element.useYn)
        formData.append('fileList[' + i + '].fileVO.clntId', element.clntId)
        i++
      })
      await multiFileUpload(formData, false)
      return true
    },

    onRowUpdating(e) {
      if (this.isRowReadOnly(e.oldData)) return
      var datagrid = this.GetDataGrid(this.dxDataGridRef)
      datagrid.selectRows(e.key, true)
    },
  },
}
</script>

<style scoped>
::v-deep .dx-tooltip-wrapper .dx-overlay-content {
  max-width: 480px;
  overflow: visible;
}
.history-tooltip {
  display: flex;
  flex-direction: column;
  text-align: left;
  padding: 4px 2px;
  max-width: 460px;
  box-sizing: border-box;
}
.history-tooltip-body {
  max-height: 320px;
  overflow-y: auto;
  overflow-x: hidden;
  overscroll-behavior: contain;
  -webkit-overflow-scrolling: touch;
  outline: none;
}
.history-tooltip-title {
  font-weight: 700;
  font-size: 14px;
  margin-bottom: 8px;
}
.history-tooltip-item {
  display: flex;
  flex-direction: column;
  padding: 6px 0;
  border-top: 1px solid #eee;
}
.history-tooltip-item:first-of-type {
  border-top: none;
}
.history-tooltip-meta {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin-bottom: 6px;
}
.history-tooltip-meta-left {
  display: flex;
  gap: 2px;
  font-size: 12px;
  color: #888;
  min-width: 0;
  flex: 1;
}
.history-tooltip-field-chip {
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  padding: 2px 10px;
  border-radius: 12px;
  font-size: 11px;
  font-weight: 600;
  color: #1565c0;
  background-color: #e3f2fd;
  line-height: 1.4;
  white-space: nowrap;
}
.history-tooltip-compare {
  display: flex;
  flex-direction: row;
  align-items: stretch;
  gap: 6px;
}
.history-tooltip-col {
  display: flex;
  flex-direction: column;
  gap: 2px;
  flex: 1;
  min-width: 0;
}
.history-tooltip-label {
  font-size: 11px;
  color: #999;
  flex-shrink: 0;
}
.history-tooltip-value {
  font-size: 12px;
  color: #333;
  padding: 6px 8px;
  border-radius: 4px;
  background-color: #f5f5f5;
  width: 100%;
  box-sizing: border-box;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  cursor: default;
}
.history-tooltip-before {
  color: #888;
  text-decoration: line-through;
}
.history-tooltip-after {
  color: #1565c0;
  font-weight: 600;
  background-color: #e3f2fd;
}
.history-tooltip-arrow {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  color: #bbb;
  flex-shrink: 0;
  line-height: 1;
  padding-top: 14px;
}
.history-tooltip-full-text {
  white-space: pre-line;
  word-break: break-all;
}
.history-tooltip-empty {
  font-size: 13px;
  color: #888;
}
::v-deep td.blue-cell {
  font-weight: 500;
  color: #2196f3 !important;
}
</style>
